<app-pesquisa-base #modal titulo="Meus Acompanhamentos" 
    subtitulo="Clique duas vezes em cima da linha do registro para abrir os atendimentos do paciente." 
    (registroSelecionado)="selecionado($event)">
    <ng-template appFiltroPesquisa>
        <form [formGroup]='modelo' [ngClass]="{'submitted': submetido}">
            <div class="filtro-container">
                <label class="filtro-titulo">
                    <i class="fal fa-filter"></i>Filtros
                </label>

                <div class="filtro-campos">
                    <div class="filtro-campo-auto">
                        <ejs-checkbox label='Filtrar por período de retorno' [(checked)]="filtrarPorRetorno"></ejs-checkbox>
                    </div>
                </div>
                
                <div class="filtro-campos" *ngIf="filtrarPorRetorno">
                    <div class="filtro-campo" required>
                        <ejs-daterangepicker [showClearButton]="false" [strictMode]="false"  
                            [presets]="presets.defaults"          
                            [placeholder]="'Período de Retorno'" [floatLabelType]="'Always'" 
                            formControlName="datasRetorno"></ejs-daterangepicker>
                        <app-error-handler [control]="modelo.get('datasRetorno')"
                            [submitted]='submetido' [errorType]="'required'">
                        </app-error-handler>
                    </div>
                </div>
                
                <div class="filtro-acao">
                    <input type="button" ejs-button iconCss="fas fa-search" value="Atualizar" 
                        (click)="atualizarClick()" cssClass="e-primary filtro-botao-principal"/>
                    <input type="button" ejs-button iconCss="fas fa-calendar-day" value="Apenas Hoje" 
                        *ngIf="filtrarPorRetorno"
                        (click)="preencherRetornoHoje()" cssClass="e-info filtro-botao-secundario"/>
                </div>
            </div>
        </form>
    </ng-template>
    <ng-template appConteudoPesquisa>
        <ejs-grid #grid appGridPesquisa
        [dataSource]="registros"

        [enableVirtualization]='false'  height='100%' 
        [filterSettings]='filterSettings'
        [searchSettings]='searchSettings'
        [allowFiltering]='true' 
        [allowSorting]='true' 
        [allowResizing]='true' 
        
        [toolbar]="toolbarItens"

        [selectionSettings]="{ enableToggle: false }"
        (load)="created()"
        [showColumnChooser]='true'
        [showColumnMenu]='true'
        [allowExcelExport]='true'
        [allowPdfExport]='true'
        [allowPdfExport]='true'
        >
        <e-columns>
            <e-column headerText='Geral' [columns]='columnsGeral'></e-column>
            <e-column headerText='Abertura' [columns]='columnsAbertura'></e-column>
            <e-column headerText='Última Interação' [columns]='columnsUltimaInteracao'></e-column>
            <e-column headerText='Encerramento' [columns]='columnsEncerramento'></e-column>
        </e-columns>

        <e-aggregates>
            <e-aggregate>
                <e-columns>
                    <e-column field="id" type="count">
                        <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                    </e-column>
                </e-columns>
            </e-aggregate>
        </e-aggregates>

        </ejs-grid>
    </ng-template>
</app-pesquisa-base>








<ng-template let-data #templateGravidade>
    <app-gravidade-tag [status]="data.ultimaInteracaoGravidade"></app-gravidade-tag>
</ng-template>